import styled from 'styled-components'

import Text from './Text'

const defaultValues = {
  as: 'h1',
  fontSize: ['38px','42px', '48px'],
  fontFamily: 'Proxima',
  letterSpacing: ['-1.14px', '-1.26px', '-1.44px'],
  lineHeight: ['48px','50px', '56px'],
  fontWeight: '600',
  textTransform: 'uppercase'
}

const Headline = styled(Text)``

Headline.defaultProps = {
  ...defaultValues
}

export {
  defaultValues,
  Headline
}
